import React from 'react';
import { Download } from 'lucide-react';
import { Knob } from './Knob';

/**
 * Bottom controls strip for the Batucada player:
 *  - Velocity + microphone knobs (close/over/room)
 *  - Sync + Offset (lock-to-grid)
 *  - Drag-to-DAW MIDI export placeholder
 *
 * Extracted from BatucadaRio.jsx.  Fully controlled.
 */
export const ControlsSection = ({
  close, onCloseChange,
  over, onOverChange,
  room, onRoomChange,
  sync, onSyncChange,
  offset, onOffsetChange,
  isFixedVelocity, onFixedVelocityToggle,
}) => {
  return (
    <div className="h-28 bg-gradient-to-b from-[#2a2a2a] to-[#1a1a1a] border-t border-[#444] flex items-center justify-center gap-8 px-8">
      {/* Velocity Section */}
      <div className="flex flex-col items-center gap-2">
        <div className="flex items-center gap-4">
          <button
            onClick={onFixedVelocityToggle}
            className={`px-3 py-1 rounded text-xs font-bold transition-all
              ${isFixedVelocity ? 'bg-amber-500 text-black' : 'bg-[#333] text-gray-400 hover:bg-[#444]'}`}
            data-testid="fixed-velocity-btn"
          >
            FIXED
          </button>
          <Knob value={close} onChange={onCloseChange} label="CLOSE" />
          <Knob value={over} onChange={onOverChange} label="OVER" />
          <Knob value={room} onChange={onRoomChange} label="ROOM" />
        </div>
        <div className="flex gap-8 text-[10px] text-gray-500 tracking-widest">
          <span>VELOCITY</span>
          <span>MICROPHONE</span>
        </div>
      </div>

      {/* Divider */}
      <div className="w-px h-16 bg-[#444]" />

      {/* Lock to Grid Section */}
      <div className="flex flex-col items-center gap-2">
        <div className="flex items-center gap-4">
          <Knob value={sync} onChange={onSyncChange} label="SYNC" />
          <Knob value={offset} onChange={onOffsetChange} label="OFFSET" min={-50} max={50} />
        </div>
        <span className="text-[10px] text-gray-500 tracking-widest">LOCK TO GRID</span>
      </div>

      {/* Divider */}
      <div className="w-px h-16 bg-[#444]" />

      {/* MIDI Export */}
      <div className="flex flex-col items-center gap-2">
        <div
          className="px-6 py-2 border-2 border-dashed border-amber-500/50 rounded-lg
            hover:border-amber-400 hover:bg-amber-500/10 transition-all cursor-pointer"
          data-testid="drag-to-daw"
        >
          <Download className="w-4 h-4 text-amber-400 mx-auto mb-1" />
          <span className="text-xs text-amber-400 font-medium">DRAG TO DAW</span>
        </div>
        <span className="text-[10px] text-gray-500 tracking-widest">MIDI FILE</span>
      </div>
    </div>
  );
};

export default ControlsSection;
